import React from "react";
import { getTechSpec } from "@/libs/tactsuit/getTechSpecs";
import { ProductSlug } from "@/api/product-api";
import { useTrans } from "@/utils/useTrans";

const useTrnasInteractionScrollTranslation = () => {
  const { t, tp } = useTrans(["tactsuit"]);

  return {
    weight: t("Weight"),
    weightFigures: t("2.4lb"),
    title: t("The Perfect Blend of Style and Immersion"),
    contents: t(
      "TactSuit Air comes in two styles, so you can choose the one that suits you best.",
    ),
    notification: t("More design options will be added in the future."),
  };
};

export const TactsuitInteractionScrollInfo = () => {
  const { weight, weightFigures, title, contents, notification } =
    useTrnasInteractionScrollTranslation();

  const tactsuitAirTechSpecs = getTechSpec(ProductSlug.TACTSUIT_AIR);

  return (
    <div className="align-center labtop:py-0 flex w-full flex-col justify-center overflow-hidden bg-white px-3 py-6 pb-1 laptop:bg-coolgray-10 desktop:pl-[122px]">
      <div className="px-3">
        <h2 className="text-3xl laptop:text-5xl">{weight}</h2>
        <p className="text-[80px] font-600 leading-[80px] laptop:text-[128px] laptop:leading-[128px]">
          {weightFigures}
          {/*{tactsuitAirTechSpecs.sizeDetails.weight.split("/")[1]}*/}
        </p>
      </div>
      <div className="mt-6 px-3 laptop:mt-8">
        <h2 className="text-3xl laptop:text-5xl">{title}</h2>
        <p className="mt-5 whitespace-pre-line text-base laptop:text-lg">
          {contents}
        </p>
        {/* <p className="mt-3 text-base text-coolgray-60 laptop:text-lg">
          * {notification}
        </p> */}
      </div>
    </div>
  );
};
